// © 2021 Amazon Web Services, Inc. or its affiliates. All Rights Reserved.
// This AWS Content is provided subject to the terms of the AWS Customer Agreement available at
// http://aws.amazon.com/agreement or other written agreement between Customer and either
// Amazon Web Services, Inc. or Amazon Web Services EMEA SARL or both.
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import Alert from "@awsui/components-react/alert";
import "../../index.css";
import params from "../../parameters.json";
import { Auth, API, graphqlOperation } from "aws-amplify";
import TopNavigation from "@awsui/components-react/top-navigation";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { getUpcomingMaintenances } from "../Shared/RequestService";

function Header(props) {
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const [versionText, setVersionText] = useState("");
  const [maintenanceMessage, setMaintenanceMessage] = useState(null);
  const bannerRef = useRef(null);

    useEffect(() => {
    async function checkMaintenance() {

      // make decision about redirect to maintenance page.
      try {
        const gateRes = await fetch('/maintenance.json');
        if (gateRes.ok) {
          try {
            const maintenance = await gateRes.json();
            if (maintenance && maintenance.active) {
              window.location.href = window.location.origin;
              return;
            }
          } catch (_) {}
        }
      } catch (_) {}

      // make decision about showing maintenance banner
      try {
        const active = await getUpcomingMaintenances();
        if (active.length > 0) {
          const entry = active[0];
          const fmt = (dt) => dt ? moment(dt).format("YYYY-MM-DD HH:mm") : "";
          const message = (entry.message || "")
            .replace(/\{startTime\}/g, fmt(entry.startTime))
            .replace(/\{endTime\}/g, fmt(entry.endTime));
          setMaintenanceMessage(message);
        } else {
          setMaintenanceMessage(null);
        }
      } catch (e) {
        console.error("Failed to fetch maintenance", e);
      }
    }
    checkMaintenance();
    const interval = setInterval(checkMaintenance, 60000);
    return () => clearInterval(interval);
  }, []);


  useEffect(() => {
    const height = bannerRef.current ? bannerRef.current.offsetHeight : 0;
    document.body.classList.toggle('maintenance-active', !!maintenanceMessage);
    document.documentElement.style.setProperty('--maintenance-banner-height', `${height}px`);
  }, [maintenanceMessage]);

  useEffect(() => {
    fetch("/version.txt")
      .then((res) => res.text())
      .then((text) => setVersionText(text.trim()))
      .catch(() => {});
  }, []);

  async function signOut() {
    try {
      await Auth.signOut();
    } catch (error) {
      console.log("error signing out");
    }
  }

  function Notification() {
    return (
      <Alert
        dismissible
        statusIconAriaLabel="Info"
        header="Feature announcement"
        visible={visible}
        onDismiss={() => setVisible(false)}
      >
        🚀 TEAM v1.2.0 introduces support for the use of external repositories due to CodeCommit deprecation 
      </Alert>
    );
  }

  return (
    <div>
      {maintenanceMessage && (
        <div className="maintenance-alert" ref={bannerRef}>
          <span className="maintenance-alert-text" dangerouslySetInnerHTML={{ __html: maintenanceMessage }} />
        </div>
      )}
      <TopNavigation
        identity={{
          href: "/",
          logo: {
            src: "/sopteam.png",
            alt: "SOPTEAM",
          },
        }}
        utilities={[
          {
            type: "button",
            text: "IAM Identity Center",
            href: `${params.Login}`,
            external: true,
            externalIconAriaLabel: " (opens in a new tab)",
          },
          {
            type: "button",
            iconName: "notification",
            title: "Notifications",
            ariaLabel: "Notifications (unread)",
            badge: true,
            disableUtilityCollapse: false,
            onClick: () => setVisible(true),
          },
          {
            type: "button",
            text: versionText,
            href: "https://serviceportal.soptim.de/spaces/CLOUD/pages/401117662/ST+AWS+TEAM+Soptim+Edition+CHANGELOG",
            external: true,
            externalIconAriaLabel: " (opens in a new tab)",
          },
          {
            type: "menu-dropdown",
            text: `${props.user}`,
            description: `${props.user}`,
            iconName: "user-profile",
            onItemClick: ({ detail }) => {
              if (detail.id === "signout") {
                signOut().then(() => history.push("/"));
              }
            },
            items: [
              { id: "signout", text: "Sign out" },
              {
                id: "support-group",
                text: "Support",
                items: [
                  {
                    id: "documentation",
                    text: "Documentation",
                    href: "https://aws-samples.github.io/iam-identity-center-team/",
                    external: true,
                    externalIconAriaLabel: " (opens in new tab)",
                  },
                  { id: "support", text: "Support" },
                  {
                    id: "feedback",
                    text: "Feedback",
                    href: "https://pulse.aws/survey/PZDTVK85",
                    external: true,
                    externalIconAriaLabel: " (opens in new tab)",
                  },
                  {
                    id: "bug",
                    text: "Report Bug",
                    href: "https://github.com/aws-samples/iam-identity-center-team/issues",
                    external: true,
                    externalIconAriaLabel: " (opens in new tab)",
                  },
                ],
              },
            ],
          },
        ]}
        onFollow={() => {
          history.push("/");
          props.setActiveHref("/");
          props.addNotification([]);
        }}
      />
      <Notification />
    </div>
  );
}

export default Header;
